var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Cascader',{attrs:{"data":_vm.data,"load-data":_vm.loadData,"transfer":"","disabled":_vm.disabled,"size":_vm.size,"placeholder":_vm.placeholder,"render-format":_vm.renderFormat},on:{"on-change":_vm.handleChange},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab15741a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/components/al-cascader.vue
// module id = 9
// module chunks = 0